import React from "react";
import "../style/Home.css";
import { Container } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import ListGroup from 'react-bootstrap/ListGroup';
import CFIScatterPlot from "./CFIScatterPlot";


const GetPlotData = (study, user, plotType) => {

    const dataList = [];
    study.trainee_ids.forEach((trainee_id, index) => {
        const traineeName = trainee_id === user.id ? study.traineeNames[index] : "OTHERS";
        const plotData = {
            xArray: [],
            yArray: [], 
            trainee_id: trainee_id,
            xLabel: 'Simulation Number',
            yLabel: plotType === 'Q' ? 'Flow (0.0-1.0)' : 'Time Taken (mins)',
            dataLabel: traineeName,
            color: trainee_id === user.id ? '#F02424' : '#979799',
            step: plotType === 'Q' ? 0.2 : 5.0,
        };
        dataList.push(plotData);
    });

    study.simulations.forEach(simulation => {
        const thisTraineeID = simulation.trainee_id;
        const thisPlotData = dataList.find(data => data.trainee_id === thisTraineeID);  
        const parts = simulation.simulationID.split('-');
        const simNumber = parseInt(parts[parts.length - 1], 10);
        thisPlotData.xArray.push(simNumber);
        const data = simulation.meta;
        if (data) {
            if (plotType === 'Q') {
                thisPlotData.yArray.push(data.Q);
            } else if (plotType === 'T') {
                if (data.time_taken > 1.0) { // So we are not plotting 0 values (no time)
                thisPlotData.yArray.push(data.time_taken);
            } else {
                    thisPlotData.yArray.push(null);
                }
            }
        } else {
            thisPlotData.yArray.push(null);
        }
    });
    return dataList;
}


const StudyFeedback = ({ study, user }) => {

    return (
        <Container className="mb-5">
            <Row>
                {user.id && 
                    // Initialize arrays


                    <Row>
                        
                        <Col>   
                            <CFIScatterPlot dataList={GetPlotData(study, user, 'Q')} />
                        </Col>
                        <Col>
                            <CFIScatterPlot dataList={GetPlotData(study, user, 'T')} />
                        </Col>
                    </Row>
                }

                {user.feedbacks &&
                    <Row>
                        <Col className="border border rounded-2 m-3">
                            <Row>
                                <Col>
                                    <h4>Review</h4>
                                </Col>
                            </Row>
                            <Row>
                                <ListGroup>
                                    {user.feedbacks.map(
                                        (iFeedback) =>
                                            iFeedback.study_id.toString() === study.studyID.toString() &&
                                            iFeedback.feedbackType === 'Problem' &&
                                            <ListGroup.Item key={"Problem" + iFeedback.id}>
                                                {iFeedback.feedbackText}
                                            </ListGroup.Item>
                                    )}
                                </ListGroup>
                            </Row>
                        </Col>
                        <Col className="border border rounded-2 m-3">
                            <Row>
                                <Col>
                                    <h4>Comments</h4>
                                </Col>
                            </Row>
                            <Row>
                                <ListGroup>
                                    {user.feedbacks.map(
                                        (iFeedback) =>
                                            iFeedback.study_id.toString() === study.studyID.toString() &&
                                            iFeedback.feedbackType === 'Improvement' &&
                                            <ListGroup.Item key={"Improvement" + iFeedback.id}>
                                                {iFeedback.feedbackText}
                                            </ListGroup.Item>
                                    )}
                                </ListGroup>
                            </Row>
                        </Col>
                        <Col className="border border rounded-2 m-3">
                            <Row>
                                <Col>
                                    <h4>Suggestions</h4>
                                </Col>
                            </Row>
                            <Row>
                                <ListGroup>
                                    {user.feedbacks.map(
                                        (iFeedback) =>
                                            iFeedback.study_id.toString() === study.studyID.toString() &&
                                            iFeedback.feedbackType === 'Feedback' &&
                                            <ListGroup.Item key={"Feedback" + iFeedback.id}>
                                                {iFeedback.feedbackText}
                                            </ListGroup.Item>
                                    )}
                                </ListGroup>
                            </Row>
                        </Col>
                    </Row>
                }
            </Row>
        </Container>
    );
};

export default StudyFeedback;
